var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04325 17.0707C0.782905 17.331 0.782905 17.7531 1.04325 18.0135L1.98606 18.9563C2.24641 19.2166 2.66852 19.2166 2.92887 18.9563L9.99994 11.8852L17.0711 18.9563C17.3314 19.2167 17.7535 19.2167 18.0139 18.9563L18.9567 18.0135C19.217 17.7532 19.217 17.3311 18.9567 17.0707L11.8856 9.9996L18.9566 2.92854C19.217 2.66819 19.217 2.24608 18.9566 1.98573L18.0138 1.04292C17.7535 0.782569 17.3314 0.782569 17.071 1.04292L9.99994 8.11399L2.92892 1.04296C2.66857 0.782614 2.24646 0.782614 1.98611 1.04296L1.0433 1.98577C0.782947 2.24612 0.782948 2.66823 1.0433 2.92858L8.11432 9.99961L1.04325 17.0707Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCloseIcon);
export default __webpack_public_path__ + "static/media/profile-close-icon.f570b470d15a041bc1f09cd3c471b25a.svg";
export { ForwardRef as ReactComponent };